import { ref } from 'vue'
import { defineStore } from 'pinia'
import type { UnreadMessagesByGroupMap } from '@shared/types/messaging'

export const useUnreadMessagesStore = defineStore('unreadMessages', () => {
  const unreadMessagesByGroup = ref<UnreadMessagesByGroupMap>({
    totalUnreadMessages: 0,
    groups: {},
  })

  const setUnreadMessagesByGroup = (_unreadMessagesByGroup: UnreadMessagesByGroupMap) => {
    unreadMessagesByGroup.value = _unreadMessagesByGroup
  }

  return { unreadMessagesByGroup, setUnreadMessagesByGroup }
})
